import React from "react";
import {ReactComponent as BMLogo} from '../svg_assets/bookmark30.svg';
import Button from "react-bootstrap/esm/Button";

const CircleButtonComponent = (props, {size = 50, color = "#198754", iconColor = "#ffffff" }) => {
  var buttoncolor = ""
  if(props.disabled){
    buttoncolor="#adb5bd"
  }
  else{
    buttoncolor = props.color?props.color: color
  }
  return (
    <Button
      className="circle-button"
      style={{
        width: props.size?props.size:size,
        height: props.size?props.size:size,
        backgroundColor: buttoncolor,
      }}
      onClick={props.onClick}
      disabled={props.disabled?props.disabled:false}
    >
      <BMLogo
        style={{ width: "75%", height: "75%", fill: iconColor }}
        aria-label="Circle Button Icon"
      />
    </Button>


  );
};

export default CircleButtonComponent;